import { v4 as uuidv4 } from 'uuid';

var Singleton = (function (){
  var cache;
  var _data = null;
  var today = new Date();

  var date = today.getFullYear() +
    '-' +
    (today.getMonth() + 1) +
    '-' +
    today.getDate();

  var time = today.getHours() +
    ":" +
    today.getMinutes() +
    ":" +
    today.getSeconds();

  return function (fn) {
    if (typeof cache === 'object') return cache;
    this.p = 'public';
    this.id = uuidv4();
    this.date = date + ' ' + time;
    this.isFetching = false;
    this.hasData = false;
    this.dataExpire = false;

    let _this = this

    this.setData = function(data, timeout = 10000) {
      _data = data
      setTimeout(function() {
        console.log('clear status... !!!')
        _this.hasData = false
        _this.dataExpire = true
        _data = null
      }, timeout)
    };
    this.getData = function() {
      delete _data['__ob__']
      return _data
    };

    // this.status = {
    //   isFetching: false,
    //   hasData: false,
    //   dataExpire: true,
    // }

    var args = arguments[0]

    args.forEach(f => {
      this[f.name] = f.fn
    })

    cache = this;
  }
}())

export default Singleton



// WEBPACK FOOTER //
// ./src/Singleton.js